module.exports = __webpack_public_path__ + "media/images/item/reco_hr-f128d1914a17f1d7d0105a9a78a474db.gif";